import { memo } from 'react';
import { Node, NodeProps } from '@xyflow/react';
import { RouteNodeType } from '@lp/features/RoutePlanner/types';
import { HubIcon } from '@icons';
import { NodeHandleConnections } from './NodeHandleConnections';

export type HubNodeProps = Node<RouteNodeType['data'], 'hubNode'>;

export const HubNode = memo(({ data }: NodeProps<HubNodeProps>) => {
  return (
    <NodeHandleConnections>
      <div className="flex justify-center gap-1 border-1 items-center pl-0 pr-0.5 rounded-sm text-white bg-aquamarine-10 border-aquamarine-10">
        <HubIcon width={16} height={16} />
        <span className="font-mono text-s-sb uppercase">{data.title}</span>
      </div>
    </NodeHandleConnections>
  );
});
